﻿import { FC, useEffect } from 'react';
import { defaultSEO, PageSEOProps } from '../../config/seo';

export const SEOHead: FC<PageSEOProps> = ({
  title,
  description,
  canonicalUrl,
  ogImage,
  ogType = 'website',
  noIndex = false,
  jsonLd
}) => {
  const fullTitle = title
    ? defaultSEO.titleTemplate.replace('%s', title)
    : defaultSEO.defaultTitle;

  const metaDesc = description || defaultSEO.defaultDescription;
  const canonical = canonicalUrl || defaultSEO.baseUrl;
  const image = ogImage || defaultSEO.defaultOgImage;
  const robots = noIndex ? 'noindex, nofollow' : defaultSEO.robots;

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.title = fullTitle;

      const setMetaTag = (attr: string, key: string, content: string) => {
        let el = document.querySelector(`meta[${attr}="${key}"]`);
        if (!el) {
          el = document.createElement('meta');
          el.setAttribute(attr, key);
          document.head.appendChild(el);
        }
        el.setAttribute('content', content);
      };

      setMetaTag('name', 'description', metaDesc);
      setMetaTag('name', 'robots', robots);
      setMetaTag('property', 'og:title', fullTitle);
      setMetaTag('property', 'og:description', metaDesc);
      setMetaTag('property', 'og:type', ogType);
      setMetaTag('property', 'og:url', canonical);
      setMetaTag('property', 'og:image', image);
      setMetaTag('name', 'twitter:card', 'summary_large_image');
      setMetaTag('name', 'twitter:title', fullTitle);
      setMetaTag('name', 'twitter:description', metaDesc);

      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute('href', canonical);
    }
  }, [fullTitle, metaDesc, canonical, image, ogType, robots]);

  if (!jsonLd) {
    return null;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(jsonLd)
      }}
    />
  );
};

